import 'css-chunksrc/client/pages/projectPage/kanbanPage/column/styles.scss';export default {
  "column": "_column_1ycww_1",
  "selectedColumn": "_selectedColumn_1ycww_10",
  "heading": "_heading_1ycww_14",
  "title": "_title_1ycww_24",
  "canDrag": "_canDrag_1ycww_36",
  "progressBar": "_progressBar_1ycww_48",
  "iconBox": "_iconBox_1ycww_55",
  "icon": "_icon_1ycww_55",
  "tasks": "_tasks_1ycww_68",
  "task": "_task_1ycww_68",
  "draggedTask": "_draggedTask_1ycww_89",
  "loader": "_loader_1ycww_94",
  "loaderMain": "_loaderMain_1ycww_102",
  "columnDropBox": "_columnDropBox_1ycww_109",
  "contextualMenu": "_contextualMenu_1ycww_113",
  "binIcon": "_binIcon_1ycww_120",
  "basic": "_basic_1ycww_126",
  "progress": "_progress_1ycww_48",
  "dropZone": "_dropZone_1ycww_133",
  "dropZoneInList": "_dropZoneInList_1ycww_150",
  "nameAndNumberOfTasks": "_nameAndNumberOfTasks_1ycww_154",
  "numberOfTasks": "_numberOfTasks_1ycww_159",
  "dragged": "_dragged_1ycww_89"
};